<template>
  <v-container class="text-top">
    <v-row>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="450"
        transition="dialog-top-transition"
      >
        <v-card>
          <v-alert dense type="success"> {{ dialogHead }} </v-alert>
          <v-card-text class="text-subtitle-2">{{ dialogMessage }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="dialog = false"> 확인 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog
        v-model="dialogConform"
        persistent
        max-width="450"
        transition="dialog-top-transition"
      >
        <v-card color="blue-grey lighten-5">
          <v-alert dense type="success"> {{ dialogHead }} </v-alert>
          <v-card-text class="text-subtitle-2">{{ dialogMessage }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onConfirm"
            >
              예(OK)
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onCancel"
            >
              아니오(NO)
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog
        v-model="dialogSelect"
        persistent
        max-width="450"
        transition="dialog-top-transition"
      >
        <v-card color="blue-grey lighten-5">
          <v-alert dense type="success"> 선택확인 </v-alert>
          <v-card-title class="text-subtitle-2">{{
            dialogMessage
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onConfirm"
            >
              예(OK)
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onCancel"
            >
              아니오(NO)
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog
        v-model="dialogUpdate"
        persistent
        max-width="450"
        transition="dialog-top-transition"
      >
        <v-card color="blue-grey lighten-5">
          <v-alert dense type="success"> 수정 </v-alert>
          <v-card-title class="text-subtitle-2"
            >변경된 내용을 수정하시겠습니까</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onConfirm"
            >
              수정
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onCancel"
            >
              취소
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog
        v-model="dialogDelete"
        persistent
        max-width="450"
        transition="dialog-top-transition"
      >
        <v-card color="blue-grey lighten-5">
          <v-alert dense type="success"> 삭제 </v-alert>
          <v-card-title class="text-subtitle-2"
            >{{ dialogMessage }} 선택 내용을 삭제하시겠습니까?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onConfirm"
            >
              삭제
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              class="font-weight-bold primary--text"
              outlined
              @click="onCancel"
            >
              취소
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-row>
      <v-dialog
        v-model="dialogInsert"
        persistent
        max-width="450"
        transition="dialog-top-transition"
      >
        <v-card color="blue-grey lighten-5">
          <v-alert dense type="success"> 입력 </v-alert>
          <v-card-title class="text-subtitle-2"
            >입력 내용을 저장하시겠습니까?</v-card-title
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onConfirm">입력</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onCancel">취소</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
import EventBus from "../EventBus";

export default {
  data() {
    return {
      dialog: false,
      dialogHead: "",
      dialogMessage: "",

      dialogConform: false,
      dialogUpdate: false,
      dialogDelete: false,
      dialogInsert: false,
      dialogSelect: false,

      pushDivision: "",
    };
  },
  computed: {},

  created() {
    EventBus.$off("push-msg");
    EventBus.$on("push-msg", (payload) => {
      this.oninitMeteCode(payload);
    });

    EventBus.$off("push-comFirm");
    EventBus.$on("push-comFirm", (payload) => {
      this.oninitComForm(payload);
    });

    EventBus.$off("push-update");
    EventBus.$on("push-update", (param) => {
      console.log("EventBus oninitUpdate ", param);
      this.oninitUpdate(param);
    });

    EventBus.$off("push-delete");
    EventBus.$on("push-delete", (param) => {
      this.oninitDeletee(param);
    });

    EventBus.$off("push-insert");
    EventBus.$on("push-insert", (param) => {
      this.oninitInsert(param);
    });

    EventBus.$off("push-select");
    EventBus.$on("push-select", (param) => {
      this.oninitSelect(param);
    });
  },

  beforeDestroy() {
    // EventBus.$off("push-msg");
    // EventBus.$off("push-update");
    // EventBus.$off("push-delete");
    // EventBus.$off("push-insert");
  },

  methods: {
    oninitMeteCode(payload) {
      this.dialogHead = payload.Head;
      this.dialogMessage = payload.Message;
      this.dialog = true;
      console.log("oninitMeteCode", payload);
    },
    oninitComForm(param) {
      this.dialogConform = true;
      this.pushDivision = param.Type;
      this.dialogHead = param.Head;
      this.dialogMessage = param.Message;
      console.log("oninitComForm", param);
    },
    oninitUpdate(param) {
      this.dialogUpdate = true;
      this.pushDivision = param.pushDivision;
    },
    oninitDeletee(param) {
      this.dialogDelete = true;
      this.pushDivision = param.pushDivision;
      this.dialogMessage = param.Message;
    },
    oninitInsert(param) {
      console.log("oninitInsert", param);
      this.dialogInsert = true;
      this.pushDivision = param.pushDivision;
    },

    oninitSelect(param) {
      this.dialogHead = param.Head;
      this.dialogMessage = param.Message;
      this.dialogSelect = true;
      this.pushDivision = param.pushDivision;
    },
    onCancel() {
      this.oncloseDialog();
      let param = {
        pushDivision: this.pushDivision,
        result: "99",
      };
      //EventBus.confirmDisplay(param);
      EventBus.$emit("push-confirm", param);
    },

    onConfirm() {
      this.oncloseDialog();
      let param = {
        pushDivision: this.pushDivision,
        result: "00",
      };
      //EventBus.confirmDisplay(param);
      EventBus.$emit("push-confirm", param);
    },

    oncloseDialog() {
      this.dialogConform = false;
      this.dialogUpdate = false;
      this.dialogDelete = false;
      this.dialogInsert = false;
      this.dialogSelect = false;
    },
  },
};
</script>
